export default __webpack_public_path__ + "static/media/Vinci Sans Regular.424867c5.ttf";